import DialogModal from 'components/modal/dialog-modal';

import { IAudienceMembersDetailsDialog } from './types';
import { DialogContainer } from '../shared/dialog';
import { AudienceMembersDialogHeader } from './components/audience-members-dialog-header';
import { AudienceMembersList } from './components/audience-members-list';

export const AudienceMembersDetailsDialog = ({
  audienceMembers,
  onCancel,
}: IAudienceMembersDetailsDialog) => {
  const { members, title, isEveryone } = audienceMembers;

  return (
    <DialogModal open={true} withoutPadding maxWidth="650px" handleClose={onCancel}>
      <AudienceMembersDialogHeader
        audienceName={title}
        isEveryone={isEveryone}
        membersCount={members.length}
        onCancel={onCancel}
      />
      <DialogContainer>
        <AudienceMembersList members={members} />
      </DialogContainer>
    </DialogModal>
  );
};
